import { Input } from '@fountain/fountain-ui-components';
import { Grid } from '@material-ui/core';
import React from 'react';
import { useIntl } from 'react-intl';

import { Error } from 'components/Error';
import { useFieldEnhancementOptionsContextState } from 'components/FormBuilder/FieldEnhancementOptions/context';

import { useTextDataField } from './hooks';
import { TextFieldQuestionFormMessages } from './messages';
const {
  questionFormQuestionValidationLabel,
  questionFormQuestionValidationMessageLabel,
} = TextFieldQuestionFormMessages;

export const TextFieldForm = () => {
  const intl = useIntl();
  const { values, errors, handleChange } = useTextDataField();
  const { applyRegexValidation } = useFieldEnhancementOptionsContextState();
  return (
    <>
      {applyRegexValidation && (
        <>
          <Grid item xs={12}>
            <Input
              label={intl.formatMessage(questionFormQuestionValidationLabel)}
              value={values.format}
              required
              disabled={!applyRegexValidation}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                handleChange({ format: event.target.value })
              }
              error={Boolean(errors.format)}
            />
            <Error error={errors.format} align="right" />
          </Grid>
          <Grid item xs={12}>
            <Input
              label={intl.formatMessage(
                questionFormQuestionValidationMessageLabel,
              )}
              value={values.format_validation_message}
              disabled={!applyRegexValidation}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                handleChange({ format_validation_message: event.target.value })
              }
              error={Boolean(errors.format_validation_message)}
            />
            <Error error={errors.format_validation_message} align="right" />
          </Grid>
        </>
      )}
    </>
  );
};
